import React from 'react';
import InstituteLayout from "./InstituteLayout";
import TutorProfile from "../tutor/TutorProfile";

const ViewTutorProfile = () => {
    return (
        <InstituteLayout>
            <TutorProfile/>
        </InstituteLayout>
    );
};

export default ViewTutorProfile;